import ApplicationAdapter from 'register-partners-js/adapters/application';

export default class RegistrationAdapter extends ApplicationAdapter {}
